// @ts-nocheck
import { useCallback, useState } from 'react';
import globalHeaders from 'utils/globalHeaders';
import axios from 'config/api';
import beautifyUrl from 'utils/beautifyUrl';
import { Logger } from 'utils/logger';
import { logCustomError } from 'lib/logger';

function useSave(path, config = {}) {
  const {
    headers = {},
    transformSuccess,
    transformFail,
    method = 'post',
    params = {},
    query = {},
    onFailure,
    downloadBlob,
  } = config;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mutate = useCallback(
    async (values, query, params, onSuccess, onError) => {
      setLoading(true);
      try {
        let status = 200;
        let headers = {};
        let response = await axios({
          method,
          url: beautifyUrl(path, {
            ...config,
            query: query || config?.query,
            params: params || config?.params,
          }),
          data: values,
          headers: { ...globalHeaders(), ...headers },
          responseType: downloadBlob ? 'blob' : undefined,
          // ...axiosConfig
        });
        if (transformSuccess) {
          status = response.status;
          response = transformSuccess(response);
        } else {
          headers = response.headers;
          status = response.status;
          response = response.data;
        }
        setData(response);
        setLoading(false);
        if (onSuccess) {
          onSuccess(response, status, query, headers);
        }
        if (config?.onSuccess) {
          config.onSuccess(response, status, query, headers);
        }
      } catch (err) {
        Logger.error({ message: 'Error occured', data: err });
        logCustomError({
          message: `Error occured on: ${method}`,
          errorType: 'UseSave',
          category: 'DATA PARSE',
          errInfo: err,
        });
        let e = err.response;
        let status = 500;
        if (e) {
          status = e.status;
          if (transformFail) {
            e = transformFail(e);
          } else if (e?.data instanceof Blob) {
            e = e?.data;
          } else {
            e = e?.data?.error || e?.data?.message || 'Server Error';
          }
        } else {
          e = 'Server Error';
        }
        setError(e);
        setLoading(false);
        if (onError) {
          onError(e, status, err?.response?.data);
        }
        if (config?.onError) {
          config?.onError(e, status, err?.response?.data);
        }
        if (onFailure) {
          onFailure(e, status, err?.response?.data);
        }
        if (config?.onFailure) {
          config?.onFailure(e, status, err?.response?.data);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(params), JSON.stringify(query)],
  );
  return [mutate, { data, setData, loading, error }];
}
export default useSave;
